






















import { Vue, Component, Prop } from 'vue-property-decorator';
import draggable from 'vuedraggable';
import { ISortData } from '@/interface/GamesManagement';

@Component({
  components: {
    draggable,
  },
})
export default class GamesManagementBody extends Vue {
  @Prop() readonly data!: Array<ISortData>;

  @Prop() readonly isEditSort!: boolean;

  @Prop() readonly sortData!: Function

  newSortData() {
    this.sortData(this.data);
  }
}
